import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column mb-10 bg-light rounded p-5" }
const _hoisted_2 = { class: "fw-bold fs-1" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-start" }
const _hoisted_4 = { class: "form-check form-check-lg form-check-custom form-check-solid pe-5" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "form-check-label d-flex align-items-center" }, [
  /*#__PURE__*/_createVNode("i", { class: "bi bi-check-lg fs-3 text-success" })
], -1)
const _hoisted_6 = { class: "form-check form-check-lg form-check-custom form-check-solid pe-5" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "d-flex align-items-center form-check-label" }, [
  /*#__PURE__*/_createVNode("i", { class: "bi bi-exclamation-diamond fs-3 text-danger" })
], -1)
const _hoisted_8 = { class: "form-check form-check-lg form-check-custom form-check-solid" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "form-check-label fw-bold text-gray-700 fs-5" }, " Não se aplica ", -1)
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "d-flex flex-nowrap overflow-auto align-items-start my-3" }
const _hoisted_12 = { class: "overlay" }
const _hoisted_13 = { class: "overlay-wrapper" }
const _hoisted_14 = {
  key: 1,
  class: "mw-200px me-1",
  controls: ""
}
const _hoisted_15 = { class: "overlay-layer bg-dark bg-opacity-10" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "w-100"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " Girar ", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Girando... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "fa fa-camera fs-3" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "Adicionar imagens", -1)
const _hoisted_22 = {
  key: 0,
  class: "border p-2 mt-3"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("h4", null, "Imagens para adicionar:", -1)
const _hoisted_24 = { class: "d-flex flex-nowrap overflow-auto align-items-start mb-3" }
const _hoisted_25 = { class: "overlay-wrapper" }
const _hoisted_26 = {
  key: 1,
  class: "mw-200px me-1",
  controls: ""
}
const _hoisted_27 = { class: "overlay-layer bg-dark bg-opacity-10" }
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("span", _hoisted_2, _toDisplayString(_ctx.resposta.item), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("label", _hoisted_4, [
        _createVNode(_component_Field, {
          class: "form-check-input",
          type: "radio",
          name: _ctx.resposta.itemId,
          value: 1,
          modelValue: _ctx.resposta.resposta,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.resposta.resposta = $event)),
          onChange: _ctx.atualizarResposta
        }, null, 8, ["name", "modelValue", "onChange"]),
        _hoisted_5
      ]),
      _createVNode("label", _hoisted_6, [
        _createVNode(_component_Field, {
          class: "form-check-input",
          type: "radio",
          name: _ctx.resposta.itemId,
          value: 2,
          modelValue: _ctx.resposta.resposta,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.resposta.resposta = $event)),
          onChange: _ctx.atualizarResposta
        }, null, 8, ["name", "modelValue", "onChange"]),
        _hoisted_7
      ]),
      _createVNode("label", _hoisted_8, [
        _createVNode(_component_Field, {
          class: "form-check-input",
          type: "radio",
          name: _ctx.resposta.itemId,
          value: 0,
          modelValue: _ctx.resposta.resposta,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.resposta.resposta = $event)),
          onChange: _ctx.atualizarResposta
        }, null, 8, ["name", "modelValue", "onChange"]),
        _hoisted_9
      ])
    ]),
    _createVNode(_component_Field, {
      name: "obs",
      as: "textarea",
      rows: "3",
      class: "border border-secondary mt-3",
      modelValue: _ctx.resposta.observacao,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.resposta.observacao = $event)),
      onChange: _ctx.atualizarResposta
    }, null, 8, ["modelValue", "onChange"]),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.evidencias, (evidencia, index) => {
          return (_openBlock(), _createBlock("div", { key: index }, [
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                (_ctx.isImage(evidencia.url))
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: evidencia.url,
                      class: "img-thumbnail mw-100px me-1"
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createBlock("video", _hoisted_14, [
                      _createVNode("source", {
                        src: evidencia.url
                      }, null, 8, ["src"])
                    ]))
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("button", {
                  onClick: ($event: any) => (_ctx.removeEvidencia(evidencia.id, index)),
                  class: "btn btn-sm btn-danger"
                }, [
                  _hoisted_16
                ], 8, ["onClick"])
              ])
            ]),
            (_ctx.isImage(evidencia.url))
              ? (_openBlock(), _createBlock("div", _hoisted_17, [
                  _createVNode("button", {
                    ref: 
                (el) => {
                  _ctx.submitButton[index] = el;
                }
              ,
                    id: "kt_sign_in_submit",
                    class: "btn btn-sm btn-dark",
                    onClick: ($event: any) => (_ctx.girar(evidencia, index))
                  }, [
                    _hoisted_18,
                    _hoisted_19
                  ], 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createVNode("button", {
        class: "btn btn-sm btn-secondary d-flex align-items-center",
        onClick: _cache[5] || (_cache[5] = 
          () => {
            _ctx.input.click();
          }
        )
      }, [
        _hoisted_20,
        _hoisted_21
      ]),
      _createVNode("input", {
        type: "file",
        multiple: "multiple",
        accept: "video/*|image/*",
        onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onFileAdd && _ctx.onFileAdd(...args))),
        class: "form-control-file d-none",
        id: "my-file",
        ref: 
          (el) => {
            _ctx.input = el;
          }
        
      }, null, 544),
      (_ctx.previewList.length)
        ? (_openBlock(), _createBlock("div", _hoisted_22, [
            _hoisted_23,
            _createVNode("div", _hoisted_24, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.previewList, (item, j) => {
                return (_openBlock(), _createBlock("div", {
                  key: j,
                  class: "overlay"
                }, [
                  _createVNode("div", _hoisted_25, [
                    (item.indexOf('jpg') >= 0 || item.indexOf('jpeg') >= 0 || item.indexOf('png') >= 0)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          src: item,
                          class: "img-thumbnail mw-100px me-1"
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createBlock("video", _hoisted_26, [
                          _createVNode("source", { src: item }, null, 8, ["src"])
                        ]))
                  ]),
                  _createVNode("div", _hoisted_27, [
                    _createVNode("button", {
                      onClick: ($event: any) => (_ctx.removeImagem(j)),
                      class: "btn btn-sm btn-danger"
                    }, [
                      _hoisted_28
                    ], 8, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}